import { Control, useController } from "react-hook-form";
import styled from "styled-components";
import { FC, useMemo } from "react";
import { UnitItem, UnitsDropdown } from "../ui-kit";
import { MeasurementUnits } from "@shared_packages/toolkit/types";

const Container = styled.div`
  padding-top: 10px;
  width: 100%;
`;

export enum UnitTypes {
  LENGTH = "length",
  WEIGHT = "weight",
  VOLUME = "volume",
}

interface UnitsDropDownFormFieldProps {
  name: string;
  unitName: string;
  className?: string;
  control?: Control<any>;
  label: string;
  unitType?: UnitTypes;
}

export const UnitsDropDownFormField: FC<UnitsDropDownFormFieldProps> = ({
  name,
  unitName,
  className,
  control,
  label,
  unitType = UnitTypes.LENGTH,
}) => {
  const { field } = useController({ name, control });
  const { field: unitField } = useController({ name: unitName, control });

  const handleChange = (val: UnitItem) => {
    field.onChange(val.value);
    unitField.onChange(val.unit);
  };

  const items = useMemo(() => {
    switch (unitType) {
      case UnitTypes.LENGTH:
        return [
          MeasurementUnits.CENTIMETERS,
          MeasurementUnits.MILLIMETRES,
          MeasurementUnits.METRES,
          MeasurementUnits.FEET,
          MeasurementUnits.INCHES,
        ];
      case UnitTypes.VOLUME:
        return [
          MeasurementUnits.MILLILITRES,
          MeasurementUnits.LITRES,
          MeasurementUnits.PINTS,
          MeasurementUnits.GALLONS,
        ];
      case UnitTypes.WEIGHT:
        return [
          MeasurementUnits.GRAMS,
          MeasurementUnits.KILOGRAMS,
          MeasurementUnits.POUNDS,
          MeasurementUnits.TONES,
        ];
    }
  }, [unitType]);

  return (
    <Container className={className}>
      <UnitsDropdown
        items={items}
        label={label}
        onChange={handleChange}
        value={field.value}
        unitValue={unitField.value}
      />
    </Container>
  );
};
